import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Select } from 'antd';
import { Button, Input } from 'ui/styled';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
import { selectAgentSkills, useNicStore } from 'stores/nic/stores/nicStore';
import { useNicService } from 'stores/nic/useNicService';
var PhoneTab = function () {
    var calls = useCallStore(selectCalls);
    var setShowAdditionalDirectory = useCallStore().setShowAdditionalDirectory;
    var agentSkills = useNicStore(selectAgentSkills);
    var holdCurrentAndDialPhone = useNicService().holdCurrentAndDialPhone;
    var currentCallIndex = calls.findIndex(function (c) { return c.call !== null; });
    var outboundSkills = useMemo(function () { return agentSkills.filter(function (s) { return s.isOutbound; }); }, [agentSkills]);
    var _a = useState(''), phoneNumber = _a[0], setPhoneNumber = _a[1];
    var _b = useState(null), selectedSkillId = _b[0], setSelectedSkillId = _b[1];
    var handleCall = function () {
        if (!phoneNumber.trim() || selectedSkillId === null)
            return;
        setShowAdditionalDirectory(false);
        holdCurrentAndDialPhone(phoneNumber.trim(), selectedSkillId, currentCallIndex);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: { display: 'flex', gap: 8, paddingBottom: 8 }, children: [_jsx(Input, { placeholder: "Phone number", value: phoneNumber, onChange: function (e) { return setPhoneNumber(e.target.value); }, style: { flex: 1 } }), _jsx(Button, { onClick: handleCall, disabled: !phoneNumber.trim() || selectedSkillId === null, children: "Call" })] }), phoneNumber.trim() && (_jsx(Select, { placeholder: "Select skill", value: selectedSkillId, onChange: setSelectedSkillId, showSearch: { optionFilterProp: 'label' }, options: outboundSkills
                    .sort(function (a, b) { return a.skillName.localeCompare(b.skillName); })
                    .map(function (skill) { return ({
                    label: skill.skillName,
                    value: skill.skillId
                }); }), style: { width: '100%' } }))] }));
};
export default PhoneTab;
